export default "__VITE_ASSET__CfJ4Wvx9__"